/* eslint-disable no-plusplus */
import React from 'react';
import {
  Table,
} from 'reactstrap';
import 'firebase/storage';

// eslint-disable-next-line import/prefer-default-export
export const AllClientsTable = ({ clientList, handleChange }) => {
  let i = clientList ? clientList.length : 0;
  return (
    <div
      style={{
        height: '420px',
        overflowY: 'auto',
        display: 'block',
        width: '100%',
      }}
    >
      <Table
        responsive
        size="sm"
        bordered
        striped
        hover
        style={{
          backgroundColor: '#e6f2ff',
        }}
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Pincode</th>
          </tr>
        </thead>
        <tbody>
          {clientList && clientList.map(client => (
            <tr
              key={client.value}
              onClick={() => { handleChange(client); }}
              style={{ cursor: 'pointer' }}
            >
              <td>
                {i--}
              </td>
              <td>
                {client.label ? (
                  <div>
                    {client.label}
                  </div>
                ) : (
                  <div />
                )}
              </td>
              <td>
                {client.pincode ? (
                  <div>
                    {client.pincode}
                  </div>
                ) : (
                  <div />
                )}
              </td>
            </tr>
          ))
              }
        </tbody>
      </Table>
    </div>
  );
};
